module.exports = __webpack_public_path__ + "img/material-image07.91d18ad4.png";